"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var Carousel_1 = require("./Carousel");

exports["default"] = Carousel_1["default"];